<template>
  <v-container :id="files.name">
    <view-intro :heading="files.name" />

    <material-card
      icon="mdi-clipboard-text"
      icon-small
      :title="`Recieved files`"
      color="accent"
      class="pa-4 mb-4"
    >
      <!-- <div class="py-3" />
      <div class="px-4 mb-4">
         <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </div> -->
    </material-card>
    <div v-if="!loading">
      <v-row v-if="files.length > 0">
        <v-col
          cols="12"
          sm="6"
          md="4"
          lg="3"
          v-for="(file, index) in userData.recievedFiles"
          :key="index"
        >
          <v-card class="mx-auto">
            <v-img
              class="white--text align-end"
              height="200px"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAMAAACahl6sAAAAIVBMVEX09PS2trbMzMzo6OjPz8/b29vAwMDu7u7Dw8O4uLje3t6y659EAAABeUlEQVR4nO3c3U7CQBCAUYqI4Ps/sD8FExOdmNnZTjHnJNxu9utOS3rTwwEAAAAAAAAAAODLMuT6/ju/dDd8Gu247qVk7ESW/ZQUdOyj5NuGUiEf87WDktETueX0l9z2cco776NkvaLHgRVOyy6ma53zwZA9lJScyKq3pDCkt6QypLWkNKTzPikN6SypDWksqR2txpLi0eorKR6tvmfXhJCekhkhLSVTQjrukykhHSVzQhpK5oxWQ8mk0dq+ZNJofdi2ZDzk9bf3+OVctss/GA/5yXEdsOJVQzNDluJVQ0JCQvKEhI7rv2LxqiEnEhKSJyQkJE9ISEiekJCQPCEhIXlCQkLyhISE5AkJCckTEhKSJyQkJE9ISEiekJCQPCEhIXlCQkLyhISE5AkJCckTEhKSJyQkJE9ISEiekJCQPCEhIXlCQm0hl+dal2tTSLH7x7oePuRe8vghy/8JuXaFZL9BF+oIKbb9U+tppi1DAAAAAAAAAAAAtvMGsDkRBZH0SJMAAAAASUVORK5CYII="
            >
              <v-card-title class="primary--text"
                ><strong>{{ file.media[0].name }}</strong></v-card-title
              >
            </v-img>
            <v-card-subtitle class="pb-0">
              <strong>{{ file.name }}</strong>
            </v-card-subtitle>
            <v-card-actions>
              <v-btn
                color="primary"
                icon
                :download="file.name"
                :href="getLink(file.media[0].url)"
                target="_blank"
              >
                <v-icon>mdi-download</v-icon>
              </v-btn>
              <v-btn
                color="purple"
                icon
                @click="initializeShare(file.name, file.id)"
              >
                <v-icon>mdi-share-variant</v-icon>
              </v-btn>
              <v-btn
                color="red"
                icon
                @click="initiateDelete(file.id, file.name)"
              >
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-card v-else height="500">
        <img src="../assets/Laptop-01.svg" alt="" class="empty-img" />
        <v-card-title class="text--secondary text-h4 mx-auto mt-n16 empty-text"
          ><strong>You have not recieved any files</strong></v-card-title
        >
      </v-card>
    </div>
    <div v-else>
      <v-progress-linear indeterminate color="primary"></v-progress-linear>
      <v-card-title class="text--secondary text-h6 mx-auto mt-n16 empty-text"
        ><strong>Getting your folders</strong></v-card-title
      >
    </div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-form ref="fileShareForm" @submit.prevent="shareFile">
          <v-card-title>
            <span class="text-h4 my-2"
              ><strong>Share {{ fileToShare.name }} With</strong></span
            >
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-autocomplete
                filled
                label="Select Users"
                :items="usersToShare"
                item-text="username"
                item-value="id"
                v-model="selected"
                :rules="[v => !!v || 'You must select a user to proceed']"
                small-chips
                clearable
                hide-details
                no-data-text="No available users"
              ></v-autocomplete>
            </v-container>
          </v-card-text>
          <v-card-actions class="pr-6 pb-5">
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialog = false">
              Cancel
            </v-btn>
            <v-btn color="primary" type="submit" :loading="sharingFile">
              Share
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5">
          Delete this file?
        </v-card-title>
        <v-card-text
          >You are about to remove <strong>{{ selectedName }}.</strong> This
          action cannot be reversed.</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="deleteDialog = false">
            Cancel
          </v-btn>
          <v-btn
            color="error"
            :loading="isDeleting"
            text
            @click.native="deleteFile"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  name: "Recieved",
  data() {
    return {
      search: "",
      files: [],
      dialog: false,
      users: [],
      selected: [],
      currentUser: {},
      loading: false,
      userData: {},
      deleteDialog: false,
      deletingFile: "",
      isDeleting: false,
      mediaID: "",
      selectedName: "",
      sharingFile: false,
      fileToShare: {
        name: "",
        id: ""
      }
    };
  },
  methods: {
    async getUsers() {
      const AuthToken = localStorage.getItem("AuthToken");
      axios.defaults.headers.common.Authorization = AuthToken;
      try {
        const userUrl = `${process.env.VUE_APP_BASE_URL}/users`;
        const userResponse = await axios.get(userUrl);
        this.users = userResponse.data;
        console.log(userResponse);
      } catch (error) {
        this.$toast.error("Something went wrong getting users");
      }
    },
    async getCurrentUser() {
      this.loading = true;
      const AuthToken = localStorage.getItem("AuthToken");
      axios.defaults.headers.common.Authorization = AuthToken;
      try {
        const userUrl = `${process.env.VUE_APP_BASE_URL}/users/me`;
        const userResponse = await axios.get(userUrl);
        const userDataUrl = `${process.env.VUE_APP_BASE_URL}/users/${userResponse.data.id}`;
        const userResponseData = await axios.get(userDataUrl);
        this.userData = userResponseData.data;
        this.currentUser = userResponse.data;
        this.files = userResponseData.data.recievedFiles;
        console.log(userResponse);
      } catch (error) {
        this.$toast.error("Something went wrong getting user");
      } finally {
        this.loading = false;
      }
    },
    initialiseUpload(e) {
      console.log(e);
      const fileData = new FormData();
      fileData.append("files", e);
      this.uploadData = fileData;
    },
    initiateDelete(id, name) {
      this.deletingFile = id;
      this.selectedName = name;
      this.deleteDialog = true;
    },
    async deleteFile() {
      this.isDeleting = true;
      try {
        const newFiles = this.userData.recievedFiles.filter(file => {
          return file.id !== this.deletingFile;
        });
        console.log("new files", newFiles);
        await axios.put(
          `${process.env.VUE_APP_BASE_URL}/users/${this.currentUser.id}`,
          {
            recievedFiles: newFiles
          }
        );
        this.deletingFile = "";
        this.mediaID = "";
        this.deleteDialog = false;
        this.$toast.success("File removed successfully");
        // this.getFiles();
        this.getCurrentUser();
      } catch (error) {
        console.log(error);
        this.$toast.error("Something went wrong, Could not delete this file");
      } finally {
        this.isDeleting = false;
      }
    },
    initializeShare(name, id) {
      this.fileToShare = {
        name: name,
        id: id
      };
      this.dialog = true;
    },
    async shareFile() {
      if (this.$refs.fileShareForm.validate()) {
        this.sharingFile = true;
        const AuthToken = localStorage.getItem("AuthToken");
        axios.defaults.headers.common.Authorization = AuthToken;
        const file = this.userData.recievedFiles.find(file => {
          return file.id === this.fileToShare.id;
        });
        try {
          const userUrl = `${process.env.VUE_APP_BASE_URL}/users/${this.selected}`;
          const userData = await axios.get(userUrl);
          if (userData.data.recievedFiles.find(e => e.id === file.id)) {
            this.$toast.info(`${userData.data.username} already has this file`);
          } else {
            const update = await axios.put(userUrl, {
              recievedFiles: [file, ...userData.data.recievedFiles]
            });
            console.log(update);
            await axios.put(
              `${process.env.VUE_APP_BASE_URL}/users/${this.currentUser.id}`,
              {
                sharedNumber: this.currentUser.sharedNumber + 1
              }
            );
          }

          this.$toast.success("File Shared Successfully");
          this.selected = [];
          this.dialog = false;
        } catch (error) {
          this.$toast.error("Something went wrong getting user");
        } finally {
          this.sharingFile = false;
        }
      }
    },
    getLink(link) {
      let index = link.indexOf("upload");
      index = index + 6;
      return `${link.substring(0, index)}/fl_attachment${link.substring(
        index
      )}`;
    }
  },
  computed: {
    usersToShare() {
      return this.users.filter(user => {
        return user.id !== this.currentUser.id;
      });
    }
  },
  beforeMount() {
    const AuthToken = localStorage.getItem("AuthToken");
    if (AuthToken) {
      this.getUsers();
      this.getCurrentUser();
    } else {
      this.$router.push("/login");
    }
  }
};
</script>
<style></style>
